import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Spinner } from '@/components/spinner';
import { useAppContext } from '@/context/app';
import { ErrorCodesWizardStep1 } from './Step1';
import { cleanWizardData, WizardData } from './Model';
import { useWizard, WizardProvider } from '@/common/wizard/wizard';
import { UseFormReturn } from 'react-hook-form';
import { addServerErrors } from '@/components/forms/common/FormBase';
import { ErrorCodesWizardResult } from './Result';

const maxStep = 2

export const ErrorCodesWizardBody = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  // const {services, session, translates} = useAppContext()
  const { step} = useWizard()

  if (step === 0) {
    return <ErrorCodesWizardStep1  />
  } else if (step === 1) {
    return <ErrorCodesWizardResult />
  } else return <Spinner />
}

export const ErrorCodesWizard = ({ onDone, machineId }: {
  onDone: (id: string) => void
  machineId: string
}) => {
  return <div className='errorcode-wizard'>
    <WizardProvider<WizardData> initialData={cleanWizardData(machineId)} maxStep={maxStep}>
      <ErrorCodesWizardBody onDone={onDone} />
    </WizardProvider>
  </div>
}

export const ErrorCodesWizardPopup = ({ onClose, machineId }: {
  onClose: () => void
  machineId: string
}) => {
  return <ErrorCodesWizard onDone={onClose} machineId={machineId} />
}
